import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { SessionManager } from '../../common/helpers/session-manager';
import { PaymentService } from '../services/payment.service';
import { responseCode } from '../../common/helpers/string-helper';

@Component({
  selector: 'app-payment-error-message',
  templateUrl: './payment-error-message.component.html',
  styleUrls: ['./payment-error-message.component.css']
})
export class PaymentErrorMessageComponent implements OnInit {

  status: number;
  paymentStatusDetail: any;
  sessionId: string;

  constructor(private router: Router, private sessionManager: SessionManager, private paymentService: PaymentService) { }

  ngOnInit() {

    this.paymentStatusDetail = this.sessionManager.getPaymentStatus();
    this.status = this.paymentStatusDetail.status;
    this.sessionId = localStorage.getItem('sessionID');
  }


  retryPaymentProcess() {

    const customerDetails = this.sessionManager.getCurrentUser();
    const shopingCartItem = this.sessionManager.getShoppingCartData();
    const promoCode = this.sessionManager.getPromoCode();

    if (this.status === 3) {
      this.paymentService.postAuthorizationForPayment(this.paymentStatusDetail.transactionId, responseCode.ok,
       shopingCartItem.orderId, shopingCartItem.orderTotal,
        customerDetails.id, customerDetails.email, promoCode, this.sessionId).subscribe((response: any) => {

          if (!response.hasError) {
            // TODO Payment processing failed - Auth failed
            this.router.navigate(['receipt']);
          }
        });
    } else if (this.status === 4) {
      this.paymentService.capturePayment(this.paymentStatusDetail.transactionId, responseCode.ok, shopingCartItem.orderId,
         shopingCartItem.orderTotal, customerDetails.email, promoCode, customerDetails.id, this.sessionId ).
        subscribe((response: any) => {

          if (!response.hasError) {
            // TODO Payment processing failed - Capture failed
            this.router.navigate(['receipt']);
          }
        });
    } else if (this.status === 5) {
      this.paymentService.postTransactionStatus(this.paymentStatusDetail.transactionId, responseCode.ok, customerDetails.id,
         customerDetails.email, promoCode, this.sessionId)
        .subscribe((response: any) => {

          if (!response.hasError) {
            this.router.navigate(['receipt']);
          }
        });
    }
  }

  redirectToEmbla() {
    this.router.navigate(['order']);
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-error-message/payment-error-message.component.ts